import { render, staticRenderFns } from "./ScratchCard.vue?vue&type=template&id=ab3f20be&scoped=true"
import script from "./ScratchCard.vue?vue&type=script&lang=js"
export * from "./ScratchCard.vue?vue&type=script&lang=js"
import style0 from "./ScratchCard.vue?vue&type=style&index=0&id=ab3f20be&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab3f20be",
  null
  
)

export default component.exports